/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleWarningTypes } from './equipment-schedule-warning-types';


export interface EquipmentScheduleWarningDto { 
    type?: EquipmentScheduleWarningTypes;
    scheduleId?: string;
    scheduleName?: string | null;
    windowStart?: string;
    windowEnd?: string;
    isActiveNow?: boolean;
}



